<template>
  <tr>
    <td>{{ selectedArticle.name }}</td>
    <td>{{ quantity }}</td>
    <td>{{ selectedArticle.purchase_measurement_unit_name }}</td>
    <td>
      <ButtonActionEdit @click="$emit('edit', article)" />
      <ButtonActionDelete @click="$emit('delete', article)" />
    </td>
  </tr>
</template>

<script>
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import { parseSiFloat } from '@/utils/number'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete
  },
  props: {
    article: {
      required: true,
      type: Object
    },
    articles: {
      type: Array
    }
  },
  data () {
    return {
      selectedArticle: null
    }
  },
  computed: {
    quantity () {
      return parseSiFloat(this.article.quantity)
    }
  },
  created () {
    this.selectedArticle = this.articles.find(a => a.id === this.article.article)
  }
}
</script>
